export const moduleName = 'youthPositions';
